import { ReferenciaMaestrasFosfec } from "../../../../interfaces/ReferenciaMaestrasFosfec";


const maestrasFosfec = (dataMaestras : any) : ReferenciaMaestrasFosfec => {
    const  appModalityDddl = dataMaestras.data["modalidadPostulacion"].map((appModality: any) => {
        return {
            id: appModality.value,
            label: appModality.label,
            value: appModality.value,
        };
     });
    
       const laborTypeDdl = dataMaestras.data["tipoVinculacionLaboral"].map((laborType: any) => {
           return {
               id: laborType.value,
               label: laborType.label,
               value: laborType.value,
           };
       });

       const independentTypeDdl = dataMaestras.data["tipoIndependiente"].map((independentType: any) => {
        return {
            id: independentType.value,
            label: independentType.label,
            value: independentType.value,
        };
    });
        const docTypesDdl = dataMaestras.data["tipoIdentificacion"].map((independentType: any) => {
            return {
                id: independentType.value,
                label: independentType.label,
                value: independentType.value,
            };
    });
    const departmentsDdl = dataMaestras.data["departamentosDane"].map((departamento: any) => {
        return {
            id: departamento.value,
            label: departamento.label,
            value: departamento.value,
        };
    });

    const citiesDdl = dataMaestras.data["municipiosDane"].map((municipio: any) => {
        return {
            id: municipio.value,
            label: municipio.label,
            value: municipio.value,
            relationKey: municipio.relation_key,
        };
    });

    const neighborhoodsDdl = dataMaestras.data["distritos"].map((barrio: any) => {
        return {
            id: barrio.value,
            label: barrio.label,
            value: barrio.value,
            relationKey: barrio.relation_key,
        };
    });
    //found specific compensation fund to filter in the maestra 
    const found = dataMaestras.data["cajaCompensacion"].find(element => element.label == "Comfama");
    //elemnt found filtered in list maestra 
    const filteredArray = dataMaestras.data["cajaCompensacion"].filter((element) => element !== found);
    //concatenating found compensation fund to the list of maestra
    const compensationFundDdl = [found].concat(filteredArray).map((cajaCompensacion: any ) => {
        return {
            id: cajaCompensacion.value,
            label: cajaCompensacion.label,
            value: cajaCompensacion.value,
        };
    });

    const vulnerabilityFactorDdl = dataMaestras.data["factorVulnerabilidad"].map((factorVulnerabilidad: any ) => {
        return {
            id: factorVulnerabilidad.value,
            label: factorVulnerabilidad.label,
            value: factorVulnerabilidad.value,
        };
    });
    const lastSalaryDdl = dataMaestras.data["ultimoSalario"].map((ultimoSalario: any ) => {
        return {
            id: ultimoSalario.value,
            label: ultimoSalario.label,
            value: ultimoSalario.value,
        };
    });

    const genderDdl = dataMaestras.data["genero"].map((genero: any) => {
        return {
            id: genero.value,
            label: genero.label,
            value: genero.value,
        };
    });

    const educationLevelDdl = dataMaestras.data["nivelEducativo"].map((nivelEducativo: any) => {
        return {
            id: nivelEducativo.value,
            label: nivelEducativo.label,
            value: nivelEducativo.value,
        };
    });
    
    const zonesDdl = dataMaestras.data["zona"].map((zona: any) => {
        return {
            id: zona.value,
            label: zona.label,
            value: zona.value,
        };
    });

    const populationDdl = dataMaestras.data["poblacion"].map((poblacion: any) => {
        return {
            id: poblacion.value,
            label: poblacion.label,
            value: poblacion.value,
        };
    });

    const accountTypesDdl = dataMaestras.data["tipoCuenta"].map((tipoCuenta: any) => {
        return {
            id: tipoCuenta.value,
            label: tipoCuenta.label,
            value: tipoCuenta.value,
        };
    });

    const ethnicDdl = dataMaestras.data["pertenenciaEtnica"].map((etnia: any) => {
        return {
            id: etnia.value,
            label: etnia.label,
            value: etnia.value,
        };
    });

    const laborVinculationTypeDdl = dataMaestras.data["tipoVinculacionLaboral"].map((laborVinculationType: any) => {
        return {
            id: laborVinculationType.value,
            label: laborVinculationType.label,
            value: laborVinculationType.value,
        };
    });

    const healthCareProviderDdl = dataMaestras.data["eps"].map((healthCareProvider: any) => {
        return {
            id: healthCareProvider.value,
            label: healthCareProvider.label,
            value: healthCareProvider.value,
        };
    });

    const noPensionPayedDdl = dataMaestras.data["motivoNoPagoPension"].map((noPensionPayed: any) => {
        return {
            id: noPensionPayed.value,
            label: noPensionPayed.label,
            value: noPensionPayed.value,
        };
    });

    const financialEntityDdl = dataMaestras.data["entidadFinanciera"].map((financialEntity: any) => {  
        return {
            id: financialEntity.value,
            label: financialEntity.label,
            value: financialEntity.value,
        };
    });
    const afiliationLayoffsFundDdl = dataMaestras.data["fondoCasantias"].map((afiliationLayoffs: any) => {
        return {
            id: afiliationLayoffs.value,
            label: afiliationLayoffs.label,
            value: afiliationLayoffs.value,
        };
    });

    const otherCompensationFundDdl = dataMaestras.data["fondoPensiones"].map((otherCompensationFund: any) => {
        return {
            id: otherCompensationFund.value,
            label: otherCompensationFund.label,
            value: otherCompensationFund.value,
        };
    }); 
    const indigenousTownDdl = dataMaestras.data["puebloIndigena"].map((indigeousTown: any) => {
        return {
            id: indigeousTown.value,
            label: indigeousTown.label,
            value: indigeousTown.value,
        };
    });

    const indicateReservationDdl = dataMaestras.data["resguardoIndigena"].map((indicateReservation: any) => {
        return {
            id: indicateReservation.value,
            label: indicateReservation.label,
            value: indicateReservation.value,
        };
    });

    const discapacityConditionDdl = dataMaestras.data["condicionDiscapacidad"].map((discapacitieCondition: any) => {
        return {
            id: discapacitieCondition.value,
            label: discapacitieCondition.label,
            value: discapacitieCondition.value,
        };
    });

     return { appModalityDddl, laborTypeDdl, independentTypeDdl, docTypesDdl, departmentsDdl,compensationFundDdl, lastSalaryDdl, genderDdl, educationLevelDdl,vulnerabilityFactorDdl, zonesDdl, populationDdl,citiesDdl,neighborhoodsDdl, accountTypesDdl, ethnicDdl, laborVinculationTypeDdl, healthCareProviderDdl, noPensionPayedDdl,financialEntityDdl,afiliationLayoffsFundDdl, otherCompensationFundDdl, indigenousTownDdl, indicateReservationDdl, discapacityConditionDdl };
}

export default maestrasFosfec;